import React, { useEffect, useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Modal from '../../../ui/Modal';

const blockEl = 'invoices__contact-modal';

const ContactModal = ({
  contactName,
  isOpen,
  onClose,
  onSave,
  totalInvoices,
  variant,
  modalNameObject,
}) => {
  const isSingle = variant === 'single';
  const textHeader = `Contact${isSingle ? ` ${contactName}` : ''}`;
  const [subjectValue, setSubjectValue] = useState('');
  const [messageValue, setMessageValue] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    setButtonDisabled(subjectValue === '' || messageValue === '');
  }, [subjectValue, messageValue]);

  const renderDetailsContent = () => {
    if (isSingle) {
      return (
        <div className="mb-3">
          <div>
            <span className="font-weight-bold">{modalNameObject.name}</span>
            {modalNameObject.paddleNumber && (
              <span> (Paddle #{modalNameObject.paddleNumber})</span>
            )}
          </div>
          <div>
            Invoice # {modalNameObject.id} | {modalNameObject.location} | {modalNameObject.channel}
          </div>
        </div>
      );
    }

    return (
      <p>
        The message below will be sent to all selected ({totalInvoices}) buyers.
      </p>
    );
  };

  const handleSubjectValue = (e) => {
    setSubjectValue(e.target.value);
  };

  const handleMessageValue = (e) => {
    setMessageValue(e.target.value);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    onSave({
      subject: subjectValue,
      message: messageValue
    });
  };

  return (
    <Modal isOpen={isOpen} className={blockEl} toggle={onClose}>
      <Modal.Header toggle={onClose}>
        {textHeader}
      </Modal.Header>
      <form onSubmit={handleOnSubmit} noValidate>
        <Modal.Body>
          {renderDetailsContent()}
          <FormGroup>
            <Label for="subject">Subject</Label>
            <Input type="text" id="subject" name="subject" onChange={handleSubjectValue} />
          </FormGroup>
          <FormGroup>
            <Label for="message">Message</Label>
            <Input type="textarea" id="message" name="message" rows="9" onChange={handleMessageValue} />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" color="link" onClick={onClose}>Cancel</Button>
          <Button type="submit" color="primary" disabled={buttonDisabled}>Send Message</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

ContactModal.propTypes = {
  contactName: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  totalInvoices: PropTypes.number,
  variant: PropTypes.oneOf(['bulk', 'single']),
};

ContactModal.defaultProps = {
  contactName: '',
  isOpen: false,
  onClose: Function.prototype,
  onSave: Function.prototype,
  totalInvoices: 0,
  variant: 'single',
};

export default ContactModal;
